import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>
          Полотенце двустороннее: с одной стороны выполнено из натурального хлопка, с другой – из высококачественного полиэстера. 
          Это мягкое полотенце станет отличным подарком по любому поводу. 
          Легко стирается и отлично впитывает воду. Подходит для кухни и ванной.
        </p>
        <p>
          Цвет: белый<br>Размеры: 35×75 см<br>Материал: 50% хлопок, 50% полиэстер
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
